<template>
  <div class="form__search">
    <input class="input mobile-full" type="text" :placeholder="$t('locations.searchPlaceholder')" @input="searchLocations"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: mapActions({
    searchLocations: 'locations/searchLocations',
  }),
};
</script>



// WEBPACK FOOTER //
// src/screens/Locations/components/Search.vue